import { createStateSelectorHook } from 'src/lib/sweetState';

import { MainStore } from '../../store';

const useMainState = createStateSelectorHook(MainStore, ['blankProjectType', 'improveProjectType']);

export const useViewState = () => {
  return useMainState();
};
